import config from "@config/config";
import { firebaseInstanceBearer } from "./api";
import axios from "axios";

export const getSurveyData = async (token,isPurchase) => {
  try {
    const firebaseUserInstance = axios.create({
        baseURL: config.FIREBASE_WS_BASE_URL,
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
      });
    const response = await firebaseUserInstance.get(
      `api/customer-surveys/show?is_purchase=${isPurchase}&is_customer=true`,
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      // console.log("Error response:", error.response);
    } else if (error.request) {
      // console.log("Error request:", error.request);
    } else if (error.message) {
      // console.log("Error message:", error.message);
    }
    // re-throw the error so react-query can catch it
    throw error;
  }
};

export const skipSurvey = async (token, surveyID) => {
  try {
    const firebaseUserInstance = axios.create({
        baseURL: config.FIREBASE_WS_BASE_URL,
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
      });
    const response = await firebaseUserInstance.post(`api/customer-surveys/skip`, {surveyID});

    return response.data;
  } catch (error) {
    if (error.response) {
      // console.log("Error response:", error.response);
    } else if (error.request) {
      // console.log("Error request:", error.request);
    } else if (error.message) {
      // console.log("Error message:", error.message);
    }
    // re-throw the error so react-query can catch it
    throw error;
  }
};
